import { useAuth } from "../App";
import SectionBg from "../components/SectionBg";
import PageHero, { HERO_IMAGES } from "../components/PageHero";
import { Navigate } from "react-router-dom";
import { SocialLinksManager } from "../components/SocialLinksManager";
import { HeroImagesManager } from "../components/HeroImagesManager";

export default function Impostazioni() {
  const { isAdmin } = useAuth();

  if (!isAdmin) return <Navigate to="/dashboard" replace />;

  return (
    <div className="page-container" data-testid="impostazioni-page">
      <PageHero image={HERO_IMAGES.dashboard} kicker="Admin" title="Impostazioni" subtitle="Gestisci social e immagini del sito" />
      <SectionBg type="gold" />
      <div className="container py-8 relative">
        <SocialLinksManager />
        <HeroImagesManager />
      </div>
    </div>
  );
}
